module.exports = __webpack_public_path__ + "img/layout_bridge_1.25d4024e.png";